"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariantUpdate = exports.TraitUpdate = exports.AvatarClient = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const __1 = require("../");
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const class_transformer_1 = require("class-transformer");
const TIMEOUT_MS = 300000; // 5min
class AvatarClient {
    constructor(provider, cluster, apiKey) {
        this.provider = provider;
        this.apiKey = apiKey;
        switch (cluster) {
            case "mainnet-beta": {
                this.baseUrl =
                    "https://api.avatar.itsboots.xyz";
                this.wsUrl =
                    "wss://gxccwmjxba.execute-api.us-east-1.amazonaws.com/main";
                break;
            }
            case "devnet": {
                this.baseUrl =
                    "https://dev.api.avatar.itsboots.xyz";
                this.wsUrl =
                    "wss://ad1zl1bcf9.execute-api.us-east-1.amazonaws.com/main";
                break;
            }
            case "localnet": {
                this.baseUrl = "http://localhost:4000";
                this.wsUrl = "ws://localhost:4001";
                break;
            }
            default: {
                throw new Error(`${cluster} is not a valid Solana cluster option. Choose either 'mainnet-beta', 'devnet' or 'localnet'`);
            }
        }
    }
    async send(txBase64, txName) {
        const tx = anchor.web3.Transaction.from(Buffer.from(txBase64, "base64"));
        const signedTx = await this.provider.wallet.signTransaction(tx);
        const response = await cross_fetch_1.default(`${this.baseUrl}/${txName}`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({ tx: signedTx.serialize().toString("base64") }),
        });
        const body = await handleResponse(response);
        return body.txSig;
    }
    async createAvatarClass(avatarClassMint, attributeMetadata, variantMetadata, globalRenderingConfigUri, remoteSignerLambdaArn) {
        const getTxResponse = await cross_fetch_1.default(`${this.baseUrl}/createAvatarClass`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({
                mint: avatarClassMint,
                authority: this.provider.wallet.publicKey.toString(),
                globalRenderingConfigUri: globalRenderingConfigUri,
                attributeMetadata: attributeMetadata,
                variantMetadata: variantMetadata,
            }),
        });
        const getTxBody = await handleResponse(getTxResponse);
        const tx = anchor.web3.Transaction.from(Buffer.from(getTxBody.tx, "base64"));
        const signedTx = await this.provider.wallet.signTransaction(tx);
        const postResponse = await cross_fetch_1.default(`${this.baseUrl}/sendCreateAvatarClass`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({
                tx: signedTx.serialize().toString("base64"),
                remoteSignerLambdaArn: remoteSignerLambdaArn,
            }),
        });
        const postBody = await handleResponse(postResponse);
        return [
            new anchor.web3.PublicKey(getTxBody.avatarClass),
            new anchor.web3.PublicKey(postBody.avatarClassStorageOwner),
        ];
    }
    async createAvatar(avatarClass, avatarMint, variants) {
        const getTxResponse = await cross_fetch_1.default(`${this.baseUrl}/createAvatar`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({
                mint: avatarMint,
                avatarClass: avatarClass,
                authority: this.provider.wallet.publicKey.toString(),
                variants: variants,
            }),
        });
        const body = await handleResponse(getTxResponse);
        const txSig = await this.send(body.tx, "sendCreateAvatar");
        console.log("createAvatarTxSig: %s", txSig);
        return new anchor.web3.PublicKey(body.avatar);
    }
    async createTrait(avatarClass, traitMint, componentUri, attributeIds, traitStatus, variantMetadata, equipPaymentDetails, removePaymentDetails) {
        const getTxResponse = await cross_fetch_1.default(`${this.baseUrl}/createTrait`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({
                avatarClass: avatarClass,
                authority: this.provider.wallet.publicKey.toString(),
                traitMint: traitMint,
                componentUri: componentUri,
                attributeIds: attributeIds,
                traitStatus: traitStatus,
                variantMetadata: variantMetadata,
                equipPaymentDetails: equipPaymentDetails,
                removePaymentDetails: removePaymentDetails,
            }),
        });
        const body = await handleResponse(getTxResponse);
        const txSig = await this.send(body.tx, "sendCreateTrait");
        console.log("createTraitTxSig: %s", txSig);
        return new anchor.web3.PublicKey(body.trait);
    }
    async equipTrait(avatar, traitMint) {
        const params = new URLSearchParams({
            avatar: avatar.toString(),
            authority: this.provider.wallet.publicKey.toString(),
            traitMint: traitMint.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/equipTrait?` + params);
        const body = await handleResponse(response);
        const txSig = await this.send(body.tx, "equipTrait");
        console.log("equipTraitTxSig: %s", txSig);
    }
    async removeTrait(avatar, traitMint) {
        const params = new URLSearchParams({
            avatar: avatar.toString(),
            authority: this.provider.wallet.publicKey.toString(),
            traitMint: traitMint.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/removeTrait?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const txSig = await this.send(body.tx, "removeTrait");
        console.log("removeTraitTxSig: %s", txSig);
    }
    async beginUpdate(beginUpdateRequest) {
        var _a;
        // create beginUpdate txn
        const response = await cross_fetch_1.default(`${this.baseUrl}/beginUpdate`, {
            method: "POST",
            headers: createHeaders(this.apiKey),
            body: JSON.stringify({
                beginUpdateRequest: beginUpdateRequest,
            }),
        });
        // sign and reserialize all txns
        const body = await handleResponse(response);
        const beginUpdateRestResponse = JSON.parse(body.transactions);
        for (const base64Tx of beginUpdateRestResponse.txns) {
            // sign the tx
            const tx = anchor.web3.Transaction.from(Buffer.from(base64Tx[0], "base64"));
            const signedTx = await this.provider.wallet.signTransaction(tx);
            base64Tx[0] = signedTx.serialize().toString("base64");
        }
        // open websocket connection
        // browser check
        let socket;
        const isNode = typeof process !== "undefined" && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
        if (isNode) {
            console.log("Node env");
            socket = new isomorphic_ws_1.default(this.wsUrl);
        }
        else {
            console.log("Client side env");
            socket = new WebSocket(this.wsUrl);
        }
        const request = {
            metadata: {
                requestType: "update",
                avatar: beginUpdateRequest.avatar,
            },
            data: beginUpdateRestResponse,
        };
        // on connection open, send the signed beginUpdate tx
        socket.onopen = (_event) => {
            const requestStr = JSON.stringify({ request: request });
            console.log("sending update request: %s", requestStr);
            socket.send(JSON.stringify({ request: requestStr }));
        };
        // wait for a response from the websocket api
        const finalImage = await new Promise((resolve, reject) => {
            // Set up the timeout to reject the promise
            const timeout = setTimeout(() => {
                reject(new Error("Timeout reached"));
            }, TIMEOUT_MS);
            socket.onmessage = (event) => {
                try {
                    clearTimeout(timeout); // Clear the timeout when the message is received
                    socket.close();
                    const finalImage = {
                        imageUrl: event.data.toString(),
                    };
                    resolve(JSON.stringify(finalImage));
                }
                catch (e) {
                    reject(e);
                }
            };
        });
        console.log("update and render complete");
        return finalImage;
    }
    async getAvatarClass(avatarClass) {
        const params = new URLSearchParams({
            avatarClass: avatarClass.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/avatarClass?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const avatarClassDataObj = JSON.parse(body.avatarClass);
        const avatarClassData = class_transformer_1.plainToClass(__1.AvatarRpc.AvatarClass, avatarClassDataObj);
        return avatarClassData;
    }
    async getAvatar(avatar) {
        const params = new URLSearchParams({
            avatar: avatar.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/avatar?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const avatarDataObj = JSON.parse(body.avatar);
        const avatarData = class_transformer_1.plainToClass(__1.AvatarRpc.Avatar, avatarDataObj);
        return avatarData;
    }
    async getTrait(trait) {
        const params = new URLSearchParams({
            trait: trait.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/trait?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const traitDataObj = JSON.parse(body.trait);
        // convert the underlying payment methods into the class instance
        if (traitDataObj.equipPaymentDetails !== null) {
            const paymentMethodData = class_transformer_1.plainToClass(__1.AvatarRpc.PaymentMethod, traitDataObj.equipPaymentDetails.paymentMethodData);
            traitDataObj.equipPaymentDetails.paymentMethodData = paymentMethodData;
        }
        if (traitDataObj.removePaymentDetails !== null) {
            const paymentMethodData = class_transformer_1.plainToClass(__1.AvatarRpc.PaymentMethod, traitDataObj.removePaymentDetails.paymentMethodData);
            traitDataObj.removePaymentDetails.paymentMethodData = paymentMethodData;
        }
        const traitData = class_transformer_1.plainToClass(__1.AvatarRpc.Trait, traitDataObj);
        return traitData;
    }
    async getUpdateState(updateState) {
        const params = new URLSearchParams({
            updateState: updateState.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/updateState?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const updateStateDataObj = JSON.parse(body.updateState);
        const updateStateData = class_transformer_1.plainToClass(__1.AvatarRpc.UpdateState, updateStateDataObj);
        return updateStateData;
    }
    async getPaymentMethod(paymentMethod) {
        const params = new URLSearchParams({
            paymentMethod: paymentMethod.toString(),
        });
        const response = await cross_fetch_1.default(`${this.baseUrl}/paymentMethod?` + params, {
            headers: createHeaders(this.apiKey),
        });
        const body = await handleResponse(response);
        const paymentMethodDataObj = JSON.parse(body.paymentMethod);
        const paymentMethodData = class_transformer_1.plainToClass(__1.AvatarRpc.PaymentMethod, paymentMethodDataObj);
        return paymentMethodData;
    }
    async render(avatar) {
        var _a;
        // open websocket connection
        // browser check
        let socket;
        const isNode = typeof process !== "undefined" && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
        if (isNode) {
            console.log("Node env");
            socket = new isomorphic_ws_1.default(this.wsUrl);
        }
        else {
            console.log("Client side env");
            socket = new WebSocket(this.wsUrl);
        }
        const request = {
            metadata: {
                requestType: "render",
                avatar: avatar,
            },
            data: null,
        };
        // on connection open, send the signed render tx
        socket.onopen = (_event) => {
            const requestStr = JSON.stringify({ request: request });
            console.log("sending render request: %s", requestStr);
            socket.send(JSON.stringify({ request: requestStr }));
        };
        // wait for a response from the websocket api
        const finalImage = await new Promise((resolve, reject) => {
            // Set up the timeout to reject the promise
            const timeout = setTimeout(() => {
                reject(new Error("Timeout reached"));
            }, TIMEOUT_MS);
            socket.onmessage = (event) => {
                try {
                    clearTimeout(timeout); // Clear the timeout when the message is received
                    socket.close();
                    const finalImage = {
                        imageUrl: event.data.toString(),
                    };
                    resolve(JSON.stringify(finalImage));
                }
                catch (e) {
                    reject(e);
                }
            };
        });
        console.log("render complete");
        return finalImage;
    }
    async preview(avatar, traitEquipOverrides, traitRemoveOverrides, variantOverrides) {
        var _a;
        const traitEquipOverridesStr = [];
        for (const traitEquipOverride of traitEquipOverrides) {
            traitEquipOverridesStr.push(traitEquipOverride.toString());
        }
        const traitRemoveOverridesStr = [];
        for (const traitRemoveOverride of traitRemoveOverrides) {
            traitRemoveOverridesStr.push(traitRemoveOverride.toString());
        }
        // open websocket connection
        // browser check
        let socket;
        const isNode = typeof process !== "undefined" && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
        if (isNode) {
            console.log("Node env");
            socket = new isomorphic_ws_1.default(this.wsUrl);
        }
        else {
            console.log("Client side env");
            socket = new WebSocket(this.wsUrl);
        }
        const request = {
            metadata: {
                requestType: "preview",
                avatar: avatar,
            },
            data: {
                traitEquipOverrides: JSON.stringify(traitEquipOverridesStr),
                traitRemoveOverrides: JSON.stringify(traitRemoveOverridesStr),
                variantOverrides: JSON.stringify(variantOverrides),
            },
        };
        // on connection open, send the signed render tx
        socket.onopen = (_event) => {
            const requestStr = JSON.stringify({ request: request });
            console.log("sending render preview request: %s", requestStr);
            socket.send(JSON.stringify({ request: requestStr }));
        };
        // wait for a response from the websocket api
        const previewImage = await new Promise((resolve, reject) => {
            // Set up the timeout to reject the promise
            const timeout = setTimeout(() => {
                reject(new Error("Timeout reached"));
            }, TIMEOUT_MS);
            socket.onmessage = (event) => {
                try {
                    clearTimeout(timeout); // Clear the timeout when the message is received
                    socket.close();
                    const previewImage = {
                        imageUrl: event.data.toString(),
                    };
                    resolve(JSON.stringify(previewImage));
                }
                catch (e) {
                    reject(e);
                }
            };
        });
        console.log("preview complete");
        return previewImage;
    }
}
exports.AvatarClient = AvatarClient;
function createHeaders(apiKey) {
    const headers = {
        "content-type": "application/json",
        "x-api-key": apiKey,
    };
    return headers;
}
async function handleResponse(res) {
    if (res.status !== 200) {
        throw new Error(`${await res.text()}`);
    }
    return await res.json();
}
class TraitUpdate {
    constructor(trait, action) {
        this.trait = trait;
        this.action = action;
        this.type = "TraitUpdate";
    }
}
exports.TraitUpdate = TraitUpdate;
class VariantUpdate {
    constructor(variantId, optionId, trait) {
        this.variantId = variantId;
        this.optionId = optionId;
        this.trait = trait;
        this.type = "VariantUpdate";
    }
}
exports.VariantUpdate = VariantUpdate;
